import React from 'react'
import Link from './Link'
import { LinkProps } from './types'
import OpenNewIcon from '../Svg/Icons/OpenNew'

const LinkExternal: React.FC<LinkProps> = ({ children, iconSize = 16, ...props }) => {
  return (
    <Link external {...props}>
      {children}
      <OpenNewIcon width={iconSize} color="primary" ml="4px" />
    </Link>
  )
}

export default LinkExternal
